import React from "react";
import PropTypes from "prop-types";
import SVG from "theme/components/icons/base/SVG";

const PlayIcon = ({ color, fill, ...props }) => (
    <SVG fill={fill} viewBox="0 0 23 24" {...props}>
        <path
            stroke={color}
            d="m2.743 23.154 0.24651 0.435-0.24651-0.435zm-1.993-21.536v20.666h1v-20.666h-1zm2.2395 21.971 19.374-10.979-0.493-0.87-19.374 10.979 0.49301 0.8701zm19.306-13.625-19.374-9.6871-0.44721 0.89443 19.374 9.6872 0.4472-0.89446zm0.0687 2.6467c1.0445-0.5918 1.0051-2.1098-0.0687-2.6467l-0.4472 0.89446c0.3579 0.1789 0.371 0.6849 0.0229 0.8822l0.493 0.87zm-21.614 9.6737c0 1.1494 1.2396 1.8717 2.2395 1.3051l-0.49301-0.8701c-0.33332 0.1889-0.74651-0.0518-0.74651-0.435h-1zm1-20.666c0-0.37169 0.39116-0.61343 0.72361-0.44721l0.44721-0.89443c-0.99735-0.49868-2.1708 0.22657-2.1708 1.3416h1z"
        />
    </SVG>
);

PlayIcon.propTypes = {
    color: PropTypes.string,
    fill: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

PlayIcon.defaultProps = {
    color: "currentColor",
    fill: "none",
    height: "21px",
    viewBox: "0 0 23 24",
    width: "30px",
};

export default PlayIcon;
